import { TFunction } from "i18next"

export const PRESTAMOS_CONFIG_TYPE = {
  CONCEDIDOS: 1,
  RECIBIDOS: 2,
}

interface EstadoTipoPrestamo {
  text: string
  value: number
}

export const ESTADO_TIPO_PRESTAMO = (
  t: TFunction
): Record<number, EstadoTipoPrestamo> => {
  return {
    [PRESTAMOS_CONFIG_TYPE.CONCEDIDOS]: {
      text: `${t("config.loanGranted")}`,
      value: PRESTAMOS_CONFIG_TYPE.CONCEDIDOS,
    },
    [PRESTAMOS_CONFIG_TYPE.RECIBIDOS]: {
      text: `${t("config.loanReceived")}`,
      value: PRESTAMOS_CONFIG_TYPE.RECIBIDOS,
    },
  }
}

export const getToggleButtons = (
  setTabSelected: (value: number) => void,
  t: TFunction
) => {
  return [
    {
      id: 1,
      handleClick: () => {
        setTabSelected(
          ESTADO_TIPO_PRESTAMO(t)[PRESTAMOS_CONFIG_TYPE.CONCEDIDOS].value
        )
      },
      label: ESTADO_TIPO_PRESTAMO(t)[PRESTAMOS_CONFIG_TYPE.CONCEDIDOS].text,
      disabled: false,
    },
    {
      id: 2,
      handleClick: () => {
        setTabSelected(
          ESTADO_TIPO_PRESTAMO(t)[PRESTAMOS_CONFIG_TYPE.RECIBIDOS].value
        )
      },
      label: ESTADO_TIPO_PRESTAMO(t)[PRESTAMOS_CONFIG_TYPE.RECIBIDOS].text,
      disabled: false,
    },
  ]
}

export const obtenerIdCuentaGenerica = (
  id: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cuentas: $TSMigrationFixMe[]
): string | undefined => {
  const element = cuentas.find((cuenta) => cuenta.id === id)
  return element?.cuentaContableEmpresaBase?.id
}
